import { useEffect } from "react";

// Warm the chunks behind the primary nav destinations once, during idle. The
// public shell stays mounted across navigations, so after this runs a first-time
// visitor's click on Artiklar / Guider / a loan page resolves instantly instead
// of waiting on a cold chunk download.
const warmNavDestinations = () => {
  void import("@/pages/BlogListPage");
  void import("@/pages/KlarsprakPage");
  void import("@/pages/PrivateLoanPage");
  void import("@/pages/MortgagePage");
  void import("@/pages/BusinessLoanPage");
  void import("@/pages/LoanWithoutUCPage");
};

export const usePrefetchNavDestinations = () => {
  useEffect(() => {
    let idleId: number | undefined;
    const schedule = () => {
      if (typeof window.requestIdleCallback === "function") {
        idleId = window.requestIdleCallback(warmNavDestinations, { timeout: 5000 });
      } else {
        idleId = window.setTimeout(warmNavDestinations, 2500);
      }
    };
    // Wait until the current page has settled so prefetch never competes with it.
    const startId = window.setTimeout(schedule, 1800);
    return () => {
      window.clearTimeout(startId);
      if (idleId !== undefined) {
        if (typeof window.cancelIdleCallback === "function") window.cancelIdleCallback(idleId);
        else window.clearTimeout(idleId);
      }
    };
  }, []);
};
